import type { FieldPath, FieldValues } from "react-hook-form";
import {
  CdcTextInputField,
  type CdcTextInputFieldProps,
} from "./cdc-field-helpers";

export type CdcAddressLine1FieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<
  CdcTextInputFieldProps<TFieldValues, TName>,
  "autoComplete" | "fieldKey" | "inputMode" | "maxLength" | "pattern" | "type"
>;

export function CdcAddressLine1Field<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  required = false,
  ...props
}: Readonly<CdcAddressLine1FieldProps<TFieldValues, TName>>) {
  return (
    <CdcTextInputField
      {...props}
      autoComplete="address-line1"
      fieldKey="addressLine1"
      required={required}
      type="text"
    />
  );
}
